import { render, staticRenderFns } from "./my-contact.vue?vue&type=template&id=b9be83e6&scoped=true&"
import script from "./my-contact.vue?vue&type=script&lang=js&"
export * from "./my-contact.vue?vue&type=script&lang=js&"
import style0 from "./my-contact.vue?vue&type=style&index=0&id=b9be83e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9be83e6",
  null
  
)

export default component.exports